<aside
  class="chatbot-history flex-shrink-0 p-3 overflow-auto border-end border-light border-opacity-10"
  :aria-hidden="!is_open"
  @scroll.passive="handle_scroll"
>
  <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
    <span class="text-white-50 text-xs fw-semibold">Chats</span>
    <button
      class="btn btn-sm btn-primary rounded-circle d-inline-flex align-items-center justify-content-center p-0 chatbot-mini-btn"
      @click="$emit('new-conversation')"
      aria-label="Start new conversation"
      title="New conversation"
    >
      <i class="bi bi-plus-lg"></i>
    </button>
  </div>

  <BolideAssistantHistoryItem
    v-for="conversation in ordered_conversations"
    :key="conversation.id"
    :conversation="conversation"
    :is_active="conversation.id === active_conversation_id"
    :can_delete="conversations.length > 1 && conversation.source !== 'backend'"
    @select="$emit('select-conversation', $event)"
    @delete="$emit('delete-conversation', $event)"
  />

  <button
    v-if="has_more_conversations"
    class="btn btn-outline-light btn-sm rounded-3 text-xs d-inline-flex align-items-center justify-content-center gap-1 w-100 mt-2"
    :disabled="is_loading_conversations"
    @click="$emit('load-more-conversations')"
  >
    <i class="bi bi-arrow-down-circle"></i>
    <span>{{ is_loading_conversations ? "Loading" : "Older chats" }}</span>
  </button>
</aside>
